/**
 * @desc 转交任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  body: defs.activiti.BatchTransferTaskDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/transferTask`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
